var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkBtnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91665 11.1873L5.74999 10.1459L3.06732 7.99995L5.74999 5.85395L4.91665 4.81261L1.58332 7.47928C1.50522 7.54174 1.44217 7.62096 1.39884 7.71109C1.35551 7.80122 1.33301 7.89994 1.33301 7.99995C1.33301 8.09995 1.35551 8.19867 1.39884 8.2888C1.44217 8.37893 1.50522 8.45816 1.58332 8.52061L4.91665 11.1873ZM11.0833 4.81261L10.25 5.85395L12.9327 7.99995L10.25 10.1459L11.0833 11.1873L14.4167 8.52061C14.4948 8.45816 14.5578 8.37893 14.6011 8.2888C14.6445 8.19867 14.667 8.09995 14.667 7.99995C14.667 7.89994 14.6445 7.80122 14.6011 7.71109C14.5578 7.62096 14.4948 7.54174 14.4167 7.47928L11.0833 4.81261ZM9.98399 2.14395L7.31732 14.1439L6.01532 13.8546L8.68199 1.85461L9.98399 2.14395Z",
    fill: "#0D6F5A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBtnIcon);
export default __webpack_public_path__ + "static/media/linkBtnIcon.2569860ddc5e6a9925ca1328ee7abdb3.svg";
export { ForwardRef as ReactComponent };